import React from "react";
import { useAuth } from "../../../context/AuthContext.jsx";
import DirectoryNavbar from "../Components/navbar/DirectoryNavbar.jsx";
import PublicWall from "./PublicWall.jsx";
import LoggedInWall from "./LoggedInWall.jsx";
import "./Wall.css";

function Wall() {
 const { isAuthenticated, loading } = useAuth();

 if (loading) {
  return (
   <div className="wall-page">
    <DirectoryNavbar />
   </div>
  );
 }

 return (
  <div className="wall-page">
   <DirectoryNavbar />

   <main className="wall-main">
    {isAuthenticated ? <LoggedInWall /> : <PublicWall />}
   </main>
  </div>
 );
}

export default Wall;